import clsx from 'clsx';
import React from 'react';

type HrSize = 'default' | 'small';

type HrProps = {
  className?: string;
  size?: HrSize;
};

function Hr({ className, size = 'default' }: Readonly<HrProps>): JSX.Element {
  return <hr className={clsx('hr', size === 'small' && 'hr--size-small', className)} />;
}

export default Hr;
